import api from "@/api";
import converters from "@/converters";
import type { PictogramFragment } from "@/graphql";
import isDataReady from "@/helpers/requests/isDataReady";
import type { LoadingType } from "@/types";
import { computed, ref } from "vue";

const pictograms = ref<PictogramFragment[]>([]);
const status = ref<LoadingType>("none");

export function usePictograms() {
  const init = async () => {
    if (status.value === "loaded") {
      return;
    }

    status.value = "loading";
    pictograms.value = await api.pictograms.getAll();
    status.value = "loaded";
  };

  init();

  const refetch = async () => {
    pictograms.value = await api.pictograms.getAll();
  };

  const pictogramsList = computed(() => {
    return pictograms.value
      .map((item) => {
        return converters.pictograms.toMultiSelectItem(item);
      })
      .toSorted((a, b) => a.title.localeCompare(b.title));
  });

  const loading = computed(() => {
    return status.value === "loading";
  });

  const isReady = () => isDataReady(status);

  return {
    pictograms,
    pictogramsList,
    loading,
    isReady,
    refetch,
  };
}
